module.exports = __webpack_public_path__ + "static/media/6en.7ec954a5.jpg";